<template>
  <div class="service-box bottom-switch">
    <div class="bottom-content clearfix"
         style="height:100%;">
      <div class="step1-right fl">
        <ul class="list"
            v-if="tagsDataList.length">
          <li @click="$emit('emitClickEvent',ind)"
              v-for="(item,ind) in tagsDataList"
              :key="ind"
              v-show="ind<=10&&ind%2==0">
            <a v-if="isNotCustom">
              <div class="info fl"
                   v-if="item.others.length">{{item.others[0]&&item.others[0].standardData?item.others[0].standardData:''}}</div>
              <div class="date-m02 fr"
                   v-if="item.others.length"> {{item.others[1]&&item.others[1].standardData?(allPrice(item.others[1].standardEnName) ? formatPrice(item.others[1].standardData) : item.others[1].standardData):''}}</div>
              <div class="clear"></div>
            </a>
            <a v-else>
              <!-- <div class="info fl"> {{item[leftName]?item[leftName]:''}}</div>
                            <div class="date-m02 fr"> {{item[rightName]?item[rightName]:''}}</div> -->
              <div class="clear"></div>
            </a>
          </li>
        </ul>
      </div>
      <div class="step1-right fl">
        <ul class="list"
            v-if="tagsDataList.length">
          <li @click="$emit('emitClickEvent',ind)"
              v-for="(item,ind) in tagsDataList"
              :key="ind"
              v-show="ind<=10&&(isPc?ind%2==1:true)">
            <a v-if="isNotCustom">
              <div class="info fl"
                   v-if="item.others.length">{{item.others[0]&&item.others[0].standardData?item.others[0].standardData:''}}</div>
              <div class="date-m02 fr"
                   v-if="item.others.length"> {{item.others[1]&&item.others[1].standardData?(allPrice(item.others[1].standardEnName) ? formatPrice(item.others[1].standardData) : item.others[1].standardData):''}}</div>
              <div class="clear"></div>
            </a>
            <a v-else>
              <!-- <div class="info fl"> {{item[leftName]?item[leftName]:''}}</div>
                            <div class="date-m02 fr"> {{item[rightName]?item[rightName]:''}}</div> -->
              <div class="clear"></div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
// import ZImage from "../ZImage.vue"
export default {
  name: 'enterpris',
  components: {
    // ZImage
  },
  props: {
    tagsDataList: {
      type: Array
    },
    isNotCustom: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isPc () {
      if (window.innerWidth > 768) {
        return true;
      } else { return false; }
    }
  },
  created () {
    console.log(this.tagsDataList);
  }
}
</script>
<style scoped>
/*新闻列表1 开始*/
.service-box {
  height: 232px;
  overflow: auto;
}
.service-box .step1-right:first-child {
  border-right: 1px dashed #ddd;
}
.service-box .step1-right {
  overflow: auto;
  height: 100%;
  padding: 0 16px;
  width: calc(50% - 34px);
  width: -moz-calc(50% - 34px);
  width: -webkit-calc(50% - 34px);
}
.service-box .step1-right ul.list {
  height: 100%;
  overflow: auto;
}
.service-box .step1-right ul.list li {
  height: 34px;
  line-height: 34px;
  font-size: 14px;
}
.service-box .step1-right ul.list li a {
  display: block; /*padding-left:10px;*/
  height: 22px;
  line-height: 22px;
  background: url("../../assets/images/information_list_two_columns/m02_news_list_icon_dotted_gray.png")
    left center no-repeat;
  padding: 6px 0 6px 8px;
}
.service-box .step1-right ul.list li a div {
  font-size: 14px;
}
.service-box .step1-right ul.list li a:hover {
  background: url("../../assets/images/information_list_two_columns/m02_news_list_icon_dotted_blue.png")
    left center no-repeat;
  color: #4197ee;
}
.service-box .step1-right ul.list li .info {
  width: calc(100% - 300px);
  width: -moz-calc(100% - 300px);
  width: -webkit-calc(100% - 300px);
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
}
.service-box .step1-right ul.list li .date-m02 {
  text-align: right;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen   and (max-width: 767px) {
  .service-box .step1-right {
    padding: 0;
    margin: 16px 0;
    width: 100%;
  }
  .service-box .step1-right:first-child {
    display: none;
  }
  .service-box .step1-right ul.list li .info {
    width: calc(100% - 34px);
    width: -moz-calc(100% - 34px);
    width: -webkit-calc(100% - 34px);
  }
  .service-box .step1-right ul.list li .date-m02 {
    width: 30px;
  }
}
/*新闻列表1 结束*/
</style>>



// WEBPACK FOOTER //
// src/components/floorBlock/news.vue